import { Stack, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export const FieldWrapper = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => {
  return (
    <Stack>
      <Text fontSize={"xs"} fontWeight={"semibold"}>
        {label}
      </Text>
      {children}
    </Stack>
  );
};
